import React, { memo } from 'react';

import CustomReadMoreContent
  from '../../../../components/CustomReadMoreText/CustomReadMoreContent';
import { useTheme } from '../../../../context/ThemeProvider';
import {
  ITQShoutoutCategoryDetails,
} from '../../../../types/tqConnectTypes/user';
import PointsPill
  from '../../../Profile/screens/Leaderboard/components/PointsPill/PointsPill';

interface Props {
  coverImage: string;
  category: ITQShoutoutCategoryDetails;
  description: string;
}

const ShoutoutPreview: React.FC<Props> = ({
  coverImage,
  category,
  description,
}) => {
  const { colors: COLORS } = useTheme();
  return (
    <div className="shoutout-preview">
      <div className="preview__content">
        <img
          src={coverImage}
          alt="shoutout preview"
          className="preview__content__image"
        />

        <div className="preview__content__badge">
          <PointsPill
            type="tq"
            points={0}
            name={category.name}
            icon={
              (
                <span style={{ fontSize: 20 }}>{category.logo}</span>
              ) as unknown as string
            }
            showTQConnectBadge
            backgroundColor={COLORS.SURFACE_PAGE}
            style={{
              paddingBlock: 2,
              gap: 8,
            }}
          />
        </div>
      </div>

      <CustomReadMoreContent lines={3} className="preview__caption">
        {description}
      </CustomReadMoreContent>
    </div>
  );
};

export default memo(ShoutoutPreview);
